export const splitBoldAndRegularText = (input: string): { boldText: string; restText: string } => {
    const boldMatch = input.match(/<b>(.*?)<\/b>/);
    const boldText = boldMatch ? boldMatch[1] : '';
    let restText = input.replace(/<b>.*?<\/b>/, '').trimStart();

    if (restText.startsWith('：')) {
        // Japanese full-width colon carries its own spacing: "<b>注意</b>：text"
        restText = '：' + restText.slice(1).trimStart();
    } else if (restText.startsWith(':')) {
        // e.g. "<b>Label</b>:text" / "<b>Label</b>: text" → normalize to ": text"
        restText = ': ' + restText.slice(1).trimStart();
    } else if (boldText && restText) {
        // ensure exactly one space between the bold label and the following text,
        // regardless of whether the source content included one
        restText = ' ' + restText;
    }

    return { boldText, restText };
}